import { render, staticRenderFns } from "./IWPlayer.vue?vue&type=template&id=399f821a&scoped=true"
import script from "./IWPlayer.vue?vue&type=script&lang=js"
export * from "./IWPlayer.vue?vue&type=script&lang=js"
import style0 from "./IWPlayer.vue?vue&type=style&index=0&id=399f821a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399f821a",
  null
  
)

export default component.exports